import './inspirationblock.scss'

import {Background} from '@codeurs/front'
import {ImageType} from 'campagne/types'
import React, {FunctionComponent, ReactElement, useState} from 'react'
import {style} from 'util/style'
import {Theme} from 'views/campagne/theme'

export type InspirationBlockType = {
	image?: ImageType | string
	title: string
	description: string
	buttonArray?: Array<ReactElement>
	url?: string
}

const styles = style('categoryblock')

export const InspirationBlock: FunctionComponent<InspirationBlockType> = ({
	image,
	title,
	description,
	buttonArray
}) => {
	const buttons = buttonArray.filter(buttonItem => buttonItem !== null)

	return (
		<div class={styles}>
			<InspirationBlockBackground img={image}>
				<Theme.H3 as="h2" mod={['white', 'nobackground', 'shadow']}>
					{title}
				</Theme.H3>
			</InspirationBlockBackground>
			<InspirationContent description={description} buttons={buttons} />
		</div>
	)
}

export const InspirationContent: React.FC<{
	description: string
	buttons: Array<ReactElement>
}> = ({description, buttons}) => {
	if (!description && (!buttons || buttons.length === 0)) return
	return (
		<div class={styles('content')}>
			<Theme.Wysiwyg>{description}</Theme.Wysiwyg>
			{buttons && buttons.length > 0 && (
				<div class={styles('content-buttons')}>
					{buttons.map(button => button)}
				</div>
			)}
		</div>
	)
}

export const InspirationBlockBackground: FunctionComponent<{
	img: ImageType | string
}> = ({children, img, ...props}) => {
	if (!img)
		return <div class={styles('background').mod('noimage')}>{children}</div>

	const [imageLoaded, setImageLoaded] = useState(false)

	return (
		<div className={styles('background').is({loaded: imageLoaded})}>
			<Background
				img={img}
				className={styles('background-image').toString()}
				onload={() => setImageLoaded(true)}
			>
				{children}
			</Background>
		</div>
	)
}
